import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconArrowSmallDown = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 48,
	height: 48,
	fill: "none",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#111",
		fillRule: "evenodd",
		d: "M19.027 20 24 24.945 28.973 20l1.527 1.522L24 28l-6.5-6.478L19.027 20z",
		clipRule: "evenodd"
	})
});
export default SvgIconArrowSmallDown;
